/* esm.sh - unhead@3.1.0/dist/shared/unhead.CfgPMHXt */
export * from "/*unhead@3.1.0/esnext/dist/shared/unhead.CfgPMHXt.mjs";
